import { render, staticRenderFns } from "./PostComment.vue?vue&type=template&id=7908f11f&"
import script from "./PostComment.vue?vue&type=script&lang=ts&"
export * from "./PostComment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports